import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, IsDate } from "class-validator";
import { ApiOAuth2, ApiProperty } from "@nestjs/swagger";
export class RecruitmentActivitiesDTO{
    @ApiProperty()
    recruitmentActivityId: number;
    @ApiProperty()
    candidateName: string;

    @ApiProperty()
    activity: string;

    @ApiProperty()
    activityDate: Date;

    @ApiProperty()
    remarks: string;


    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    createdUser: string | null;
    
    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    versionFlag: number;

}